window.smartPak = window.smartPak || {};

export default function namespace(nsString) {
    const parts = nsString.split('.'),
        smartPak = window.smartPak || {};
    let parent = smartPak,
        i,
        len;

    if (parts[0] === 'smartPak') {
        parts.shift();
    }

    for (i = 0, len = parts.length; i < len; i += 1) {
        // create a property if it doesn't exist
        if (typeof parent[parts[i]] === 'undefined') {
            parent[parts[i]] = {};
        }
        parent = parent[parts[i]];
    }
    return parent;
}
